var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8861_9521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#EB6240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0366 24.0006L35.5194 18.5179C36.3584 17.6789 36.3584 16.3185 35.5194 15.4795L32.5206 12.4809C31.6815 11.6418 30.3214 11.6418 29.4822 12.4809L23.9996 17.9636L18.5168 12.4809C17.6778 11.6418 16.3174 11.6418 15.4784 12.4809L12.4798 15.4795C11.6408 16.3185 11.6408 17.6789 12.4798 18.5179L17.9626 24.0006L12.4798 29.4832C11.6408 30.3223 11.6408 31.6826 12.4798 32.5217L15.4784 35.5202C16.3174 36.3593 17.6778 36.3593 18.5168 35.5202L23.9996 30.0376L29.4822 35.5202C30.3214 36.3593 31.6815 36.3593 32.5206 35.5202L35.5194 32.5217C36.3584 31.6826 36.3584 30.3223 35.5194 29.4832L30.0366 24.0006Z",
    fill: "#F0F0FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.9661 40.9658C32.9675 48.9644 20.7601 50.1345 11.5215 44.5111C29.7606 42.1012 43.2198 28.2566 34.0503 2.19531C36.5652 3.36549 38.9053 4.97217 40.9661 7.03293C50.3443 16.3937 50.3443 31.605 40.9661 40.9658Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8861_9521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.11a80d3fdc003ceb9eebe69369f6b736.svg";
export { ForwardRef as ReactComponent };